import React, { useState, useEffect } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import "../../styles/App.css";
import GroupLabel from "../../components/GroupLabel.js";

const ExpulsionPage = () => {
  const [students, setStudents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filterField, setFilterField] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [rehousingOptions, setRehousingOptions] = useState({}); 
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const API = process.env.REACT_APP_API_BASE;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await fetch(`${API}/api/students`, {
          headers: { Authorization: getAuthHeader() },
        });
        const data = await response.json();
        const validData = data.filter(
          (student) =>
            student.id &&
            student.pib &&
            student.room_number !== undefined
        );
        setStudents(validData);
      } catch (error) {
        console.error("Помилка завантаження студентів:", error);
      }
    };

    fetchStudents();
  }, []);

  const handleExpulsion = (student) => {
    const canBeRehoused = rehousingOptions[student.id] ?? true; 
    const confirmation = window.confirm(
      `Ви впевнені, що хочете виселити ${student.pib} з ${
        student.violations
      } порушеннями? Можливість повторного поселення: ${
        canBeRehoused ? "Так" : "Ні"
      } УВАГА! Всі пов'язані дані з цим студентом теж будуть видалені!`
    );

    if (confirmation) {
      fetch(`${API}/api/expel-student/${student.id}`, {
        method: "POST",
        headers: {
          Authorization: getAuthHeader(),
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ canBeRehoused }),
      })
        .then((res) => res.json())
        .then(() => {
          alert("Студента успішно виселено!");
          setStudents(students.filter((s) => s.id !== student.id));
        })
        .catch((err) => console.error(err));
    }
  };

  const filteredStudents = students.filter((student) => {
    const pib = student.pib || ""; 
    const matchesSearch = pib.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter =
      !filterField ||
      !filterValue ||
      String(student[filterField] || "").includes(filterValue);
    return matchesSearch && matchesFilter;
  });

  // Обробка кліку на рядок
  const handleRowClick = (studentId) => {
    navigate(`/student/${studentId}`); // Перехід на сторінку студента
  };

  const handleRehousingChange = (studentId, value) => {
    setRehousingOptions((prev) => ({
      ...prev,
      [studentId]: value === "true",
    }));
  };

  //sort
  const handleSort = (field) => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);
  };

  const sortedStudents = [...filteredStudents].sort((a, b) => {
    if (!sortField) return 0;
    if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
    if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <div className="page-container">
      <div className="header-content">
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Пошук за ПІБ"
          className="header-content-input"
        />

        <select
          value={filterField}
          onChange={(e) => setFilterField(e.target.value)}
          className="header-content-input"
        >
          <option value="">Фільтр</option>
          <option value="group">Група</option>
          <option value="room_number">Кімната</option>
          <option value="rating">Рейтинг</option>
          <option value="violations">Кількість порушень</option>
        </select>

        {filterField && (
          <input
            type="text"
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            placeholder={`Введіть значення для ${filterField}`}
            className="header-content-input"
          />
        )}

        <Link to="/arhive" className="add-act-button">
          Архів
        </Link>
      </div>

      <table className="table">
        <thead>
          <tr>
            <th className="table-header" onClick={() => handleSort("pib")}>
              ПІБ{" "}
              {sortField === "pib" ? (sortOrder === "asc" ? "↑" : "↓") : "↑↓"}
            </th>
            <th className="table-header" onClick={() => handleSort("group")}>
              Група{" "}
              {sortField === "group" ? (sortOrder === "asc" ? "↑" : "↓") : "↑↓"}
            </th>
            <th
              className="table-header"
              onClick={() => handleSort("room_number")}
            >
              Кімната{" "}
              {sortField === "room_number"
                ? sortOrder === "asc"
                  ? "↑"
                  : "↓"
                : "↑↓"}
            </th>
            <th className="table-header" onClick={() => handleSort("rating")}>
              Рейтинг{" "}
              {sortField === "rating"
                ? sortOrder === "asc"
                  ? "↑"
                  : "↓"
                : "↑↓"}
            </th>
            <th
              className="table-header"
              onClick={() => handleSort("violations")}
            >
              Порушення{" "}
              {sortField === "violations"
                ? sortOrder === "asc"
                  ? "↑"
                  : "↓"
                : "↑↓"}
            </th>
            <th
              className="table-header"
              onClick={() => handleSort("acts_count")}
            >
              Акти{" "}
              {sortField === "acts_count"
                ? sortOrder === "asc"
                  ? "↑"
                  : "↓"
                : "↑↓"}
            </th>
            <th className="table-header">Повторне поселення</th>
            <th className="table-header">Дія</th>
          </tr>
        </thead>
        <tbody>
          {sortedStudents.length > 0 ? (
            sortedStudents.map((student) => (
              <tr key={student.id}>
                <td
                  onClick={() => handleRowClick(student.id)}
                  style={{ cursor: "pointer" }}
                  className="table-content"
                >
                  {student.pib}{" "}
                </td>
                <td className="table-content"><GroupLabel group={student.group} /></td>
                <td className="table-content">
                  {student.dormitory_name} - {student.room_number}
                </td>
                <td className="table-content">{student.rating}</td>
                <td className="table-content">{student.violations}</td>
                <td className="table-content">{student.acts_count}</td>
                <td className="table-content">
                  <select
                    value={rehousingOptions[student.id] ?? "true"}
                    onChange={(e) =>
                      handleRehousingChange(student.id, e.target.value)
                    }
                    className="expel-select"
                  >
                    <option value="true">Так</option>
                    <option value="false">Ні</option>
                  </select>
                </td>
                <td className="table-content">
                  <button
                    onClick={() => handleExpulsion(student)}
                    className="remove-button"
                  >
                    Виселити
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="table-content">
                Даних немає
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ExpulsionPage;
